import axios from 'axios'

export default {
  /**
   * Get all plans of system
   * @returns {AxiosPromise<any>}
   */
  getPlans () {
    return axios.get('/payment/plans')
  },

  /**
   * Check promocode
   * @param data
   * @returns {AxiosPromise<any>}
   */
  checkPromocode (data) {
    return axios.post('payment/promocode/check', data)
  },

  /**
   * Get all invoice user
   * @returns {AxiosPromise<any>}
   */
  getAllInvoices (params) {
    return axios.get('payment/invoice/all', {params})
  },

  /**
   * Make Payment Credit Card
   * @param data
   * @returns {AxiosPromise<any>}
   */
  paymentCreditCard (data) {
    return axios.post('payment/make/creditcard', data)
  },
  
   /**
   * Make acccess token
   * @param data
   * @returns {AxiosPromise<any>}
   */
   getaccesstoken (data) {
    return axios.post('payment/make/accesstoken', data)
  },


    /**
   * Make Recurring Payment Credit Card
   * @param data
   * @returns {AxiosPromise<any>}
   */
    recurringpaymentCreditCard (data) {
      return axios.post('payment/make/recurringcreditcard', data)
    },

    
      /**
   * Get all saved card details of  user
   * @returns {AxiosPromise<any>}
   */
  getsavedcard (data) {
    return axios.post('payment/card/info', data)
  },

  updatesavedcard (data) {
    return axios.post('payment/card/update', data)
  },
  getcancelmonthly_subs (data){
    return axios.post('payment/cancel/monthly_subs', data)
  }
}



// WEBPACK FOOTER //
// ./src/api/subscription.js